import { render, staticRenderFns } from "./shop-purchase-tabs.vue?vue&type=template&id=64d38818&scoped=true&"
import script from "./shop-purchase-tabs.vue?vue&type=script&lang=js&"
export * from "./shop-purchase-tabs.vue?vue&type=script&lang=js&"
import style0 from "./shop-purchase-tabs.vue?vue&type=style&index=0&id=64d38818&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d38818",
  null
  
)

export default component.exports